import { DataService } from "../axios/DataService";

const RequestInviteService = (postData) => {
  return DataService.post(`/api/requestInvite`, postData);
};

export { RequestInviteService };
